import React from "react";
import "./CustomerCard.css";

function CustomerCard({ 
  companyName,
  engName,
  ceoName,
  color = "#333",
  className = "",
  size = "default" // default, compact, large
}) {
  return (
    <div className={`customer-card-component ${size} ${className}`}>
      <div 
        className="customer-card-inner"
        style={{ backgroundColor: color }}
      >
        <div className="customer-logo">{companyName}</div>
        <p className="customer-eng">{engName}</p>
        <div className="customer-info">
          <p>{ceoName} / CEO</p>
        </div>
      </div>
    </div>
  );
}

export default CustomerCard;